import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { tasksId } from "../../../types/activityTasks";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { audiosAssets } from "../../../assets/audio";
import { useNavigate } from "react-router-dom";
import { voicesTypeControl } from "../../../types/audioType";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogInitial: 1,
	viewActivity: 200,
	dialogTwo: 2,
	dialogThree: 3,
	dialogFour: 4,
	dialogFive: 5,
	dialogSix: 6,
	dialogSeven: 7,
	dialogEight: 8,
	dialogNine: 9,
	dialogTen: 10,
	hiddenStep: 100,
};

export const Team2SubtopicTwoActivitySix = () => {
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema2.activities.subtema2], 6);

	useEffect(() => {
		if (loaded) {
			console.log('tema 2 sub 2 act 6');
			ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a01T2)
	})

	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.animationsSaveCupWaterFinish, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a05T2)
		setUiToShow(steps.dialogFive);
	});
	ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.animationsCloseCupWaterFinish, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a06T2)
		setUiToShow(steps.dialogSix);
	});
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, 100].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.initScene, 5);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 6: Maquina Frappé" />
					<DialogBarNew
						dialog={"¡Bien hecho! también tenemos nuestra maquina de Frappé. Es momento de hablar de su modo de operación."}
						percentage={"5%"}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							ObserverEmitter.emit(EVENTS.team2.subtopicTwo.activitySix.moveYelox)
							setUiToShow(steps.viewActivity);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivity && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquinas de café"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a02T2)
							ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.visibleCupWater);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<DialogBarNew
					dialog={"Iniciamos colocando agua purificada hasta la línea indicadora en la jarra, en este caso son 3 litros."}
					percentage={"10%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a03T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.visibleBagFrappe);
						setUiToShow(steps.dialogThree);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogThree && (
				<DialogBarNew
					dialog={"Posteriormente, vierte el contenido de una bolsa Frappé y revuélvelo hasta que se disuelva por completo."}
					percentage={"15%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a04T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.hiddenCupAndFrappe);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.off);
						setUiToShow(steps.dialogFour);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFour && (
				<DialogBarNew
					dialog={
						"¡Mantente alerta!, antes de verte el contenido de la jarra en el contenedor, asegúrate que la maquina se encuentre apagada."
					}
					percentage={"25%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddenoff);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.animationsSaveCupWaterInit);
						setUiToShow(steps.hiddenStep);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogFive && (
				<DialogBarNew
					dialog={`¡Se cuidadoso!, coloca el "líquido del frappé" en la máquina, evitando cualquier derrame.`}
					percentage={"35%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.animationsCloseCupWaterInit);
						setUiToShow(steps.hiddenStep);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSix && (
				<DialogBarNew
					dialog={
						"Luego de llenar los contenedores, coloca las tapas, verificando que embonen correctamente. Al finalizar el llenado, enciende la máquina."
					}
					percentage={"45%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a07T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddenon);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.alert);
						setUiToShow(steps.dialogSeven);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogSeven && (
				<DialogBarNew
					dialog={
						"1.- Localiza el switch general. 2.- Presiona el botón alarm/reset. 3.- Coloca el corbatín “en preparación”. El producto tardara 1 hora en estar listo."
					}
					percentage={"55%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a08T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddenalert);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.degrees);
						setUiToShow(steps.dialogEight);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogEight && (
				<DialogBarNew
					dialog={"Asegúrate que la pantalla muestre la disminución de temperatura hasta alcanzar los -3°C."}
					percentage={"65%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.sub02.sub2_act6_a09T2)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.hiddendegrees);
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.visibleexpiration);
						setUiToShow(steps.dialogNine);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogNine && (
				<DialogBarNew
					dialog={
						"La caducidad de la mezcla dentro de la máquina es de 7 días. Señálalo en el corbatín que colocaras a un lado del contenedor."
					}
					percentage={"75%"}
					callback={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.hiddenexpiration);
						ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
						setUiToShow(steps.dialogTen);
					}}
				></DialogBarNew>
			)}
			{uiToShow === steps.dialogTen && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda los pasos a seguir para la corecta preparción del Frappé."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 6,
									pointsWin: 0,
									subtema: tasksId.tema2.activities.subtema2,
								})
							);
							navigator("/home2/tema2/subtema2/activitySeven");
						}}
					/>
				</>
			)}
		</>
	);
};
